import React, { useEffect, useContext } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Context } from '../../context/Products';
import { emailConfirmData } from '../../assets/dummyData/emailStatus';
import { axiosLink } from '../../axiosLink';
import Helmet from '../Helmet';
import { seo } from '../../assets/dummyData/seo';

function ConfirmEmail() {
    const [{ lang }] = useContext(Context);
    const data = emailConfirmData[lang];
    const [searchParams] = useSearchParams();
    const x  = searchParams.get("token");

    useEffect(() => {
        axios.put(
            `${axiosLink}/mail/confirm`,
            { state: "ge" },
            {
                headers: {
                    token: x,
                }
            }).catch(() => {
                // The localized confirmation page remains available if the API is temporarily unavailable.
            });
    }, [x]);
    
    return (
        <>
            <Helmet title={seo[lang].confirm.title} metaDesc={seo[lang].confirm.description} lang={lang} />
            <div id="page-kontakt" className="page-plain" style={{ padding:" 40px 0 80px 0", minHeight: "70vh" }}>
                <div className="container-custom">         
                    <div className="msg-send" id="page-faq" style={{ maxWidth: "800px" }}>
                        <span className="ttl">{data?.title}</span>
                        <p>{data?.subttl}</p>
                        <br /> 
                        <p>{data?.subttl1}</p>
                        <br />  
                        <p>{data?.subttl2}</p>
                        <Link to="/" className="btn btn-primary">{data?.buttonName}</Link>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ConfirmEmail
